export const TEXT_LANGUAGES = [
  {
    id: "ENGLISH",
    short: "EN",
    pretty: "Englisch",
    prettyTranslationKey: "language_english",
    accentBg: "#E8EDFF",
    accentText: "#1e3a8a",
  },
  {
    id: "FRENCH",
    short: "FR",
    pretty: "Französisch",
    prettyTranslationKey: "language_french",
    accentBg: "#FFE9F0",
    accentText: "#9d174d",
  },
  {
    id: "GERMAN",
    short: "DE",
    pretty: "Deutsch",
    prettyTranslationKey: "language_german",
    accentBg: "#FFF4E5",
    accentText: "#92400e",
  },
  {
    id: "GREEK",
    short: "GRC",
    pretty: "Griechisch",
    prettyTranslationKey: "language_greek",
    accentBg: "#E8F8FF",
    accentText: "#0f4c81",
  },
  {
    id: "GREEK_LATIN_TRANSCRIPTION",
    short: "GRC (Latin)",
    pretty: "Griechisch (Latin Transkription)",
    prettyTranslationKey: "language_greek_latin_transcription",
    accentBg: "#EEF2FF",
    accentText: "#4338ca",
  },
  {
    id: "ITALIAN",
    short: "IT",
    pretty: "Italienisch",
    prettyTranslationKey: "language_italian",
    accentBg: "#E9F7EF",
    accentText: "#166534",
  },
  {
    id: "PORTUGUESE_FROM_BRAZIL",
    short: "BR",
    pretty: "Portugiesisch (Brasilien)",
    prettyTranslationKey: "language_portuguese_brazil",
    accentBg: "#E6FFF4",
    accentText: "#047857",
  },
  {
    id: "PORTUGUESE_FROM_PORTUGAL",
    short: "PT",
    pretty: "Portugiesisch (Portugal)",
    prettyTranslationKey: "language_portuguese_portugal",
    accentBg: "#ECF4FF",
    accentText: "#1d4ed8",
  },
  {
    id: "RUSSIAN",
    short: "RU",
    pretty: "Russisch",
    prettyTranslationKey: "language_russian",
    accentBg: "#F3E8FF",
    accentText: "#6b21a8",
  },
  {
    id: "RUSSIAN_LATIN_TRANSCRIPTION",
    short: "RU (Latin)",
    pretty: "Russisch (Latin Transkription)",
    prettyTranslationKey: "language_russian_latin_transcription",
    accentBg: "#F5F3FF",
    accentText: "#7c3aed",
  },
  {
    id: "SPANISH",
    short: "SP",
    pretty: "Spanisch",
    prettyTranslationKey: "language_spanish",
    accentBg: "#FFF1E6",
    accentText: "#c2410c",
  },
];
